import palette from './palette'
import shape from './shape'
import shadows from './shadows'
import typeset from './typeset'
// import commonStyles from './commonStyles'
import zIndex from './zIndex'
import components from './components'

const AMS = {
    palette: palette,
    shadows: shadows,
    shape: shape,
    typography: typeset,
    zIndex: zIndex,
    components: components,
    spacing: 4,
}
export default AMS